import DomainStatus from "../../DomainStatus";
import Vote from "../../Vote";

const ALL_VOTES = ["*"];


function defaultFilters()
{
    return {
        id: null,
        slug: null,
        votes: ALL_VOTES,
        page: 1,
    };
}

function defaultState()
{
    return {
        id: null,
        slug: null,
        seeds: [],
        results: [],
        suggestions: [],
        total: "-",
        hasMore: true,
        liked: 0,
        loved: 0,
        disliked: 0,
        filters: defaultFilters()
    };
}


export default {
    //Whatever is changed here, remember to also add it to the reset mutation so state is reset to the
    //same default values as here
    state: defaultState(),
    getters: {


      filters(state) {
          return state.filters;
      },

      project(state) {
          return state;
      },

      suggestions(state) {
        return state.suggestions;
      },

      proj(state) {
          return state;
      },


      page(state ) {
          return state.filters.page;
        },

      currentVote(state) {
        if (state.filters.votes === ALL_VOTES)
            return null;
          return state.filters.votes[0];
      },
    },

    mutations: {
        resetFilters(state) {
            window.console.warn("Resetting filters");

            state.total = "-";
            state.liked = 0;
            state.loved = 0;
            state.disliked = 0;
            state.filters = defaultFilters()
        },

        loadProject(state, proj) {
            window.console.warn("Loading project:", proj);

            state.id = proj.id;
            state.slug = proj.slug;
            state.seeds = proj.seeds;
            state.sylls = proj.sylls;
            state.types = proj.types;
            state.results = proj.results;
            state.suggestions = proj.suggestions;
            state.total = proj.total;
            state.liked = proj.liked;
            state.loved = proj.loved;
            state.disliked = proj.disliked;


            state.filters.id = proj.id;
            state.filters.slug = proj.slug;

            //state.filters.page = 1;
            state.hasMore = proj.has_more;
        },

        addResults(state, results) {
            const newElements = results.filter(w => ! state.results.some(r => r.id === w.id));

          state.results = state.results.concat(newElements);
          state.dispatch("fetchDomainStatus", newElements);
        },

        clearResults(state) {
            state.results = []
        },

        setVote(state, vote) {
            state.filters.votes = [vote];
        },



        setPage(state, newPage) {
            state.filters.page = newPage
        },

        setWordVote(state, deets) {
            const wordId = deets.id;
            const newVote = deets.newVote;

            const word = state.results.find(w => w.id === wordId);
            if (typeof word === "undefined") {
                window.console.warn(`No word found for id: ${wordId}`, state.results);
                return;
            }

            const prevVote = word.vote;
            word.vote = newVote;
            if (prevVote !== newVote) {
                if (prevVote !== Vote.NEUTRAL)
                    this.commit("decrementVoteCount", prevVote);

                if (newVote !== Vote.NEUTRAL)
                    this.commit("incrementVoteCount", newVote);
            }


            window.console.log(`Updated vote for ${wordId} to ${newVote}`)
        },


        decrementVoteCount(state, vote) {
          switch (vote)
          {
              case Vote.LIKED:
                  state.liked -= 1;
                  break;

              case Vote.LOVED:
                  state.loved -= 1;
                  break;

              case Vote.DISLIKED:
                  state.disliked -= 1;
                  break;

              default:
                  window.console.warn("Asked to decrement unsupported vote: ", vote);
          }
        },

        incrementVoteCount(state, vote) {
            switch (vote)
            {
                case Vote.LIKED:
                    state.liked += 1;
                    break;

                case Vote.LOVED:
                    state.loved += 1;
                    break;

                case Vote.DISLIKED:
                    state.disliked += 1;
                    break;

                default:
                    window.console.warn("Asked to decrement unsupported vote: ", vote);
            }
        },


        resetVotes(state) {
            state.filters.votes = ALL_VOTES;
        }
    }

}